import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit'
import authSlice from './auth/auth-slice'
import exampleSlice from './example/example-slice'
import { saveStateSlice } from './savestate/savestate-slice'
import { snackbarSlice } from './snackbar/snackbar-slice'

export const store = configureStore({
    reducer: {
        auth: authSlice.reducer,
        example: exampleSlice.reducer,
        snackbar: snackbarSlice.reducer,
        saveState: saveStateSlice.reducer,
    },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>
